var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 130,
    viewBox: "0 0 131 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_8754417",
    clipPath: "url(#clip0_482_7150)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5874 107.229C42.2834 107.229 23.3203 88.2655 23.3203 64.9615C23.3203 41.6574 42.2834 22.6943 65.5874 22.6943C88.8915 22.6943 107.855 41.6574 107.855 64.9615C107.855 88.2655 88.8915 107.229 65.5874 107.229Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5856 16.2976C64.5194 16.2976 63.6055 15.4599 63.6055 14.3175V1.98008C63.6055 0.913884 64.5194 0 65.5856 0C66.7279 0 67.5656 0.913884 67.5656 1.98008V14.3175C67.5656 15.4599 66.7279 16.2976 65.5856 16.2976Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9487 23.0751C90.5679 23.0751 90.2633 22.999 89.9586 22.8466C88.9686 22.3135 88.664 21.095 89.1971 20.1811L95.4419 9.44301C95.975 8.45297 97.1936 8.14834 98.1074 8.68144C99.0213 9.21454 99.4021 10.4331 98.7928 11.4231L92.6241 22.0851C92.2433 22.7705 91.6341 23.0751 90.9487 23.0751Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.453 41.658C108.768 41.658 108.083 41.2772 107.778 40.668C107.245 39.6779 107.549 38.5356 108.463 37.9263L119.201 31.7576C120.115 31.2245 121.334 31.5291 121.867 32.5192C122.4 33.4331 122.095 34.6516 121.182 35.1847L110.443 41.3534C110.139 41.5819 109.834 41.658 109.453 41.658Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.644 66.9416H116.23C115.164 66.9416 114.25 66.1039 114.25 64.9615C114.25 63.8953 115.164 62.9814 116.23 62.9814H128.644C129.71 62.9814 130.624 63.8953 130.624 64.9615C130.624 66.1039 129.71 66.9416 128.644 66.9416Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.192 98.4705C119.811 98.4705 119.506 98.3944 119.201 98.1659L108.463 91.9972C107.549 91.4641 107.245 90.2456 107.778 89.3317C108.311 88.3416 109.53 88.037 110.443 88.5701L121.182 94.815C122.095 95.3481 122.4 96.5666 121.867 97.4805C121.562 98.0897 120.877 98.4705 120.192 98.4705Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1174 121.547C96.432 121.547 95.7466 121.166 95.4419 120.557L89.1971 109.818C88.664 108.905 88.9686 107.686 89.9586 107.153C90.8725 106.62 92.091 106.924 92.6241 107.838L98.7928 118.576C99.4021 119.49 99.0213 120.709 98.1074 121.242C97.8028 121.47 97.422 121.547 97.1174 121.547Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5856 130C64.5194 130 63.6055 129.086 63.6055 128.02V115.606C63.6055 114.54 64.5194 113.626 65.5856 113.626C66.7279 113.626 67.5656 114.54 67.5656 115.606V128.02C67.5656 129.086 66.7279 130 65.5856 130Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1323 121.546C33.7515 121.546 33.4469 121.47 33.1422 121.242C32.1522 120.709 31.8476 119.49 32.3807 118.576L38.5494 107.838C39.1586 106.924 40.301 106.543 41.291 107.153C42.2049 107.686 42.5095 108.904 41.9764 109.818L35.8077 120.556C35.4269 121.165 34.8177 121.546 34.1323 121.546Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0581 98.4705C10.3726 98.4705 9.68723 98.0897 9.30644 97.4805C8.77334 96.5666 9.07797 95.3481 10.068 94.815L20.8061 88.5701C21.72 88.037 22.9385 88.3416 23.4716 89.3317C24.0047 90.2456 23.7001 91.4641 22.7862 91.9972L12.0481 98.1659C11.7435 98.3944 11.3627 98.4705 11.0581 98.4705Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9425 66.9416H2.60508C1.53888 66.9416 0.625 66.1039 0.625 64.9615C0.625 63.8953 1.53888 62.9814 2.60508 62.9814H14.9425C16.0849 62.9814 16.9226 63.8953 16.9226 64.9615C16.9226 66.1039 16.0849 66.9416 14.9425 66.9416Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7962 41.658C21.4154 41.658 21.1108 41.5819 20.8061 41.3534L10.068 35.1847C9.07797 34.6516 8.77334 33.4331 9.30644 32.5192C9.83954 31.5291 11.0581 31.2245 12.0481 31.7576L22.7862 37.9263C23.7001 38.5356 24.0047 39.6779 23.4716 40.668C23.0909 41.2772 22.4054 41.658 21.7962 41.658Z",
    fill: "#FF9D05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.301 23.0751C39.6156 23.0751 38.9302 22.7705 38.5494 22.1612L32.3807 11.4231C31.8476 10.4331 32.1522 9.21454 33.1422 8.68144C34.0561 8.14834 35.2746 8.45297 35.8077 9.44301L41.9764 20.1811C42.5095 21.095 42.2049 22.3135 41.291 22.8466C40.9864 22.999 40.6056 23.0751 40.301 23.0751Z",
    fill: "#FF9D05"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9044 88.9516C79.6759 88.9516 79.4474 88.9516 79.2189 88.7993L65.5868 83.5444L52.0309 88.7993C51.4216 89.1039 50.6601 88.9516 50.127 88.5708C49.5939 88.19 49.2892 87.5808 49.3654 86.8953L50.2031 72.3494L40.912 61.0781C40.5312 60.545 40.3789 59.8596 40.6073 59.1742C40.8358 58.5649 41.2928 58.0318 41.9782 57.8795L56.0672 54.224L63.9875 41.8866C64.2922 41.3535 64.9776 41.0488 65.5868 41.0488C66.2723 41.0488 66.8815 41.3535 67.2623 41.8866L75.1826 54.224L89.2717 57.8795C89.8809 58.0318 90.414 58.5649 90.6425 59.1742C90.871 59.8596 90.7187 60.545 90.2617 61.0781L81.0467 72.3494L81.8844 86.8953C81.8844 87.5808 81.5798 88.19 81.0467 88.5708C80.7421 88.8754 80.2851 88.9516 79.9044 88.9516Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_7150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    fill: "white",
    transform: "translate(0.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c6149a8ef4188bb09c119083dca5640e.svg";
export { ForwardRef as ReactComponent };